// extracted by mini-css-extract-plugin
export default {"user-button":"style_user-button__WETIH"};